/**
 * Ce module contient le composant principal de l'application.
 *
 * @module App
 */
import React, { useCallback, useEffect, useState } from 'react'
import './App.css'
import { Outlet, useLocation, useNavigate } from "react-router";
import { useCookies } from 'react-cookie';
import { Abonnement, OptionsAbonnement } from './Models/Abonnement/AbonnementModels';
import { Flux } from './Models/Message/MessageModels';
import { AbonnementService } from './Services/Abonnement/AbonnementService';
import { OptionsAbonnementService } from './Services/Abonnement/OptionsAbonnementService';
import { FluxService } from './Services/Message/FluxService';
import { Magasin, TypeMagasin } from './Models/Magasin/MagasinModels';
import { TypeMagasinService } from './Services/Magasin/TypeMagasinService';
import { MagasinService } from './Services/Magasin/MagasinService';
import { Identifiant } from './Models/Identifiant/IdentifiantModels';
import { IdentifiantService } from './Services/Connexion/IdentifiantService';

/**
 * Le composant principal de l'application.
 *
 * * @remarks
 * Ce composant gère plusieurs états internes :
 *
 * - `connecter`: Indique si l'utilisateur est connecté (`boolean`).
 * - `interfaceNumber`: Numéro de l'interface actuellement affichée (`number`).
 * - `switchAffichage`: Contrôle l'affichage d'une certaine partie de l'interface (`number`).
 *
 * @returns Le composant `App` qui contient l'interface utilisateur principale.
 */
export function App() {
  const [abonnementsContext, setAbonnementsContext] = useState<Abonnement[]>([]);
  const [fluxesContext, setFluxesContext] = useState<Flux[]>([]);
  const [optionsAbonnementsContext, setOptionsAbonnementsContext] = useState<OptionsAbonnement[]>([]);
  const [typesMagasinContext, setTypesMagasinContext] = useState<TypeMagasin[]>([]);
  const [magasinsContext, setMagasinsContext] = useState<Magasin[]>([]);
  const [identifiantsContext, setIdentifiantsContext] = useState<Identifiant[]>([])

  //gestion cookies app
  const [cookies] = useCookies(['token']);
  const token = cookies.token;
  let navigate = useNavigate();
  let location = useLocation(); //utilisation de l'url actuelle pour modifier elements entete

  const obtentionDonnees = useCallback(async()=>{
    const idntifiantRes = await IdentifiantService().getIdentifiants(token);
    setIdentifiantsContext(idntifiantRes);
    if(location.pathname.split("/")[1] === 'accueil' || location.pathname.split("/")[1] === 'monCompte'){
      const magRes = await MagasinService().getMagasinsUtilisateruWithAllDatas(token);
      setMagasinsContext(magRes);
      const abonnementsResult = await AbonnementService().getAbonnementsAvecMagasin(magRes, token);
      setAbonnementsContext(abonnementsResult);
      const optionAbonnementResult = await OptionsAbonnementService().getOptionsAbonnement(token);
      setOptionsAbonnementsContext(optionAbonnementResult);
      const fluxesResult = await FluxService().getFluxesUserAbonnements(abonnementsResult, token);
      setFluxesContext(fluxesResult);
      const typesMagRes = await TypeMagasinService().getTypesMagasins(token);
      setTypesMagasinContext(typesMagRes);
    }
  },[location.pathname, token])

  useEffect(()=>{
    if(!cookies.token)navigate('/login');
    return ()=>{
    }
  },[cookies.token, navigate]);

  return (
    <div className='App-Interface'>
      <Outlet context={[abonnementsContext, fluxesContext, optionsAbonnementsContext, obtentionDonnees, typesMagasinContext, magasinsContext, identifiantsContext]}/>
    </div>
  )
}
